module.exports = __webpack_public_path__ + "img/fanji.c2061e21.png";